
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetomumbaicabbookingonline() {



const cardData = {
  keyword: "Pune to Mumbai Cab Booking Online  ",
  heading: "Skyline Cabs: Pune to Mumbai Cab Booking Online ",
  headingDescription: "Skyline Cabs provides reliable and professionally managed Pune to Mumbai Cab Booking Online services for corporate travelers, IT professionals, families, and long-distance airport passengers. Whether you are traveling from central Pune, Kharadi, Baner, Hadapsar, or Pimpri-Chinchwad, we ensure smooth and timely connectivity to Chhatrapati Shivaji Maharaj International Airport. Our fleet includes well-maintained AC sedans, SUVs, and premium vehicles suitable for luggage-friendly long-distance travel. With experienced chauffeurs, punctual pickup scheduling, transparent fare structure, and 24x7 availability, Skyline Cabs ensures safe, comfortable, and stress-free airport transfers from Pune to Mumbai, all bookable conveniently online.",

  top: "Top Places to visit in Mumbai with skyline Cab",

topPlaces: [
  {
    title: "Gateway of India",
    description: "The Gateway of India, located in South Mumbai along the waterfront of Apollo Bunder, is an iconic monument built during the British Raj in 1924. Tourists arriving from Chhatrapati Shivaji Maharaj International Airport or taking sea cruises often start their Mumbai exploration here. The grand basalt arch overlooks the Arabian Sea and offers ferry services to Elephanta Caves. Its historical significance as the ceremonial entrance for British governors and royals, combined with stunning sunset views, makes it a must-visit destination for travelers seeking both heritage and photography opportunities."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive, famously called the 'Queen’s Necklace,' is a 3.6 km long boulevard along Mumbai’s Arabian Sea coastline. Travelers frequently enjoy evening walks or drives along this promenade, taking in spectacular sunset views. The area is lined with Art Deco buildings, some of which are UNESCO World Heritage Sites. Street vendors, cafes, and occasional cultural performances make it a lively yet relaxing escape from busy city life, ideal for tourists and local professionals alike."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Terminus",
    description: "Chhatrapati Shivaji Maharaj Terminus (CSMT) is a UNESCO World Heritage Site and one of the busiest railway stations in India. Its Victorian Gothic architecture combined with Indian influences is a visual treat for visitors. Tourists and business travelers arriving by train from suburban or intercity connections often marvel at the intricate stone carvings and stained-glass windows. CSMT is also a hub for Mumbai’s local culture, offering nearby street food, historical insights, and quick access to South Mumbai attractions."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is a bustling shopping street connecting the Gateway of India to the rest of South Mumbai. Tourists and local shoppers explore a mix of street markets, designer boutiques, art galleries, and iconic cafes like Leopold Cafe. Visitors traveling from the airport or railway stations frequently stop here to shop for souvenirs, handicrafts, and clothing. The vibrant atmosphere, combined with colonial-era architecture, makes it a popular destination for both leisure and cultural exploration."
  },
  {
    title: "Sanjay Gandhi National Park",
    description: "Sanjay Gandhi National Park, located in Borivali, is one of the few national parks situated within a major city. Spanning over 104 square kilometers, it offers dense forests, wildlife, and the ancient Kanheri Caves. Nature enthusiasts, trekkers, and families traveling from suburban Mumbai or nearby airports visit to experience safaris, nature trails, and historical rock-cut Buddhist caves. The park also provides educational programs about conservation, making it ideal for eco-tourism and recreational trips."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is a legendary Mumbai coastline that attracts tourists, local families, and Bollywood celebrities. Visitors often come here for leisurely evening strolls, sunset photography, and sampling Mumbai’s famous street food like bhel puri and pani puri. Its proximity to luxury hotels, high-end restaurants, and entertainment hubs makes it a prime destination for travelers seeking both relaxation and vibrant local experiences."
  },
  {
    title: "Haji Ali Dargah",
    description: "Haji Ali Dargah is a 15th-century mosque and tomb located on an islet off the coast of Worli. Accessible via a narrow causeway during low tide, it is a spiritual landmark and an architectural marvel with Indo-Islamic design elements. Pilgrims, tourists, and photographers frequently visit to witness its serene ambiance and ocean views. The dargah also symbolizes Mumbai’s communal harmony and is often included in city tours highlighting heritage and culture."
  },
  {
    title: "Chor Bazaar",
    description: "Chor Bazaar, also known as the 'Thieves Market,' is one of Mumbai’s oldest and most famous flea markets. Collectors, antique enthusiasts, and tourists arrive from across India and abroad to hunt for vintage items, furniture, Bollywood memorabilia, and quirky artifacts. Its chaotic charm, bargaining culture, and proximity to Grant Road make it an intriguing destination for those looking to explore Mumbai’s local trade and street market culture."
  },
  {
    title: "Elephanta Caves",
    description: "Elephanta Caves, a UNESCO World Heritage Site on Elephanta Island in Mumbai Harbor, are accessible via ferry from the Gateway of India. These ancient rock-cut caves date back to between the 5th and 8th centuries and feature intricate sculptures of Hindu deities, particularly Lord Shiva. Tourists often combine a ferry ride with a guided exploration of the caves, enjoying both cultural heritage and scenic views of the Arabian Sea. It is an essential destination for history buffs and spiritual travelers."
  },
  {
    title: "Bandra-Worli Sea Link",
    description: "The Bandra-Worli Sea Link is a cable-stayed bridge connecting Mumbai’s western suburbs to South Mumbai, dramatically reducing travel time. Business professionals, daily commuters, and tourists alike experience this architectural marvel for its panoramic views of the sea and skyline. Driving across at sunset is particularly popular for photographers. The bridge not only serves as a crucial transport link but has become an iconic symbol of modern Mumbai engineering and urban development."
  }
],

services: [
  {
    name: "Pune to Mumbai Cab Booking Online",
    description: "Skyline Cabs offers seamless Pune to Mumbai Cab Booking Online service designed for quick, secure, and convenient intercity travel reservations. Our online system allows instant confirmation with clear fare breakdown and vehicle category selection. We provide well-maintained, air-conditioned sedans and SUVs suitable for expressway travel with sufficient luggage space. Professional chauffeurs ensure punctual pickup from any Pune location with optimized highway routing. Transparent pricing, real-time booking confirmation, and disciplined service standards guarantee reliable online cab booking solutions."
  },
  {
    name: "Mumbai Airport to Pune Taxi Online Booking",
    description: "Mumbai Airport to Pune Taxi Online Booking service ensures smooth return intercity travel with easy digital reservation support. Skyline Cabs coordinates timely airport pickup from terminal areas with structured confirmation and route planning. Vehicles are sanitized and optimized for comfortable expressway performance. Drivers monitor traffic conditions across Mumbai corridors to maintain punctual departure. Transparent billing structure and professional online coordination ensure dependable taxi booking experiences."
  },
  {
    name: "Pune to Mumbai Taxi Booking Online",
    description: "Pune to Mumbai Taxi Booking Online service delivers efficient intercity travel reservations supported by secure payment options and instant confirmation. Skyline Cabs provides comfortable vehicles designed for long-distance expressway connectivity. Drivers carefully manage departure timing considering traffic patterns for smooth transit. Our online platform ensures easy booking, vehicle selection, and transparent pricing visibility. Reliable service execution and disciplined travel management guarantee consistent taxi booking quality."
  },
  {
    name: "Online Cab Booking Pune to Mumbai",
    description: "Online Cab Booking Pune to Mumbai service offers user-friendly reservation with structured confirmation and clear communication. Skyline Cabs ensures timely pickup from residential, corporate, and industrial areas across Pune. Vehicles are maintained for smooth highway performance and passenger comfort. Traffic monitoring and optimized routing ensure punctual arrival at the destination. Transparent fare policies and secure online booking management provide dependable intercity connectivity."
  },
  {
    name: "Pune to Mumbai Cab Online Booking",
    description: "Pune to Mumbai Cab Online Booking service provides convenient digital reservation with real-time confirmation and flexible scheduling. Skyline Cabs offers multiple vehicle categories including sedan, SUV, and premium options for comfortable travel. Drivers coordinate punctual departure based on traffic flow and expressway conditions. Our online platform ensures transparent fare breakdown and easy modification support. Professional service standards guarantee reliable booking execution."
  },
  {
    name: "Book Cab Online Pune to Mumbai",
    description: "Book Cab Online Pune to Mumbai service simplifies intercity travel planning with instant booking confirmation and secure payment options. Skyline Cabs ensures vehicle availability and structured pickup coordination from any Pune locality. Air-conditioned vehicles are optimized for smooth long-distance connectivity. Drivers align departure timing strategically to maintain punctual arrival. Transparent pricing and disciplined service management ensure dependable online booking solutions."
  },
  {
    name: "Cab Booking Pune to Mumbai",
    description: "Cab Booking Pune to Mumbai service delivers reliable intercity transportation with structured reservation and professional chauffeur coordination. Skyline Cabs provides comfortable vehicles suitable for expressway travel with adequate luggage capacity. Departure timing is planned carefully to avoid congestion and ensure timely arrival. Our booking system ensures clear fare breakdown and service transparency. Consistent driving standards and organized travel management guarantee dependable connectivity."
  },
  {
    name: "Taxi Booking Pune to Mumbai",
    description: "Taxi Booking Pune to Mumbai service offers convenient travel reservations with experienced drivers and comfortable vehicles. Skyline Cabs ensures timely pickup and optimized routing for smooth highway transit. Vehicles are sanitized and maintained for passenger comfort during long-distance journeys. We provide structured confirmation and transparent pricing policies. Professional execution and disciplined coordination maintain consistent taxi booking reliability."
  },
  {
    name: "Pune to Mumbai One Way Cab Booking Online",
    description: "Pune to Mumbai One Way Cab Booking Online service offers economical fixed-rate travel without return fare charges. Skyline Cabs ensures punctual pickup with optimized expressway routing and smooth highway performance. Our online platform provides clear fare transparency and instant confirmation. Drivers carefully manage departure timing aligned with passenger schedules. Structured service execution and transparent billing ensure dependable one-way booking solutions."
  },
  {
    name: "Pune to Mumbai Round Trip Cab Booking Online",
    description: "Pune to Mumbai Round Trip Cab Booking Online service provides convenient travel planning for return journeys with structured scheduling support. Skyline Cabs offers comfortable vehicles optimized for long-distance connectivity and luggage accommodation. Drivers coordinate departure timing for both onward and return travel segments. Our digital booking system ensures transparent fare visibility and confirmation support. Professional management and disciplined highway driving standards ensure reliable round-trip travel."
  },
  {
    name: "Pune to Mumbai Airport Cab Booking Online",
    description: "Pune to Mumbai Airport Cab Booking Online service ensures punctual airport transfers with structured digital reservation and confirmation. Skyline Cabs provides well-maintained vehicles suitable for expressway connectivity and comfortable luggage accommodation. Drivers align departure timing carefully with airport reporting schedules. Traffic monitoring and optimized routing guarantee smooth transit. Transparent pricing and professional coordination ensure dependable airport booking solutions."
  },
  {
    name: "Innova Crysta Online Booking Pune to Mumbai",
    description: "Innova Crysta Online Booking Pune to Mumbai service offers premium and spacious travel suitable for families and corporate executives. The vehicle provides superior seating comfort and enhanced luggage capacity for long-distance journeys. Online reservation ensures instant confirmation and transparent fare breakdown. Drivers coordinate punctual departure and optimized expressway routing. Structured service standards and professional management ensure premium booking reliability."
  },
  {
    name: "Ertiga Cab Online Booking Pune to Mumbai",
    description: "Ertiga Cab Online Booking Pune to Mumbai service delivers economical yet comfortable intercity travel with secure digital reservation. The vehicle ensures balanced seating comfort and adequate luggage space for highway connectivity. Drivers manage departure timing strategically to maintain punctual arrival. Online confirmation and transparent billing structure ensure clear communication. Professional service execution guarantees dependable booking outcomes."
  },
  {
    name: "Sedan Cab Online Booking Pune to Mumbai",
    description: "Sedan Cab Online Booking Pune to Mumbai service provides cost-effective intercity transportation with comfortable air-conditioned seating. Skyline Cabs ensures timely pickup and optimized highway routing for smooth expressway performance. Digital reservation offers instant confirmation and clear fare transparency. Drivers carefully align departure timing with passenger schedules. Structured coordination and disciplined driving standards ensure consistent service quality."
  },
  {
    name: "SUV Cab Online Booking Pune to Mumbai",
    description: "SUV Cab Online Booking Pune to Mumbai service offers spacious and comfortable intercity travel ideal for families and group passengers. Vehicles provide enhanced luggage capacity and stable highway performance. Online booking ensures secure reservation with transparent fare breakdown and confirmation. Drivers monitor traffic conditions and adjust routing for punctual arrival. Professional coordination and safety-focused standards guarantee reliable SUV booking solutions."
  },
  {
    name: "Pune to Mumbai One Way Cab Booking",
    description: "Pune to Mumbai One Way Cab Booking service offers fixed-rate intercity travel with clear and economical pricing. Skyline Cabs ensures punctual pickup from any Pune location with optimized expressway routing. Vehicles are comfortable and maintained for smooth long-distance connectivity. Drivers align departure timing strategically to maintain efficient travel schedules. Transparent billing and structured service management ensure dependable one-way cab solutions."
  }
],

tableData: [
  ["Pune to Mumbai Cab Booking Online", "Mumbai Airport to Pune Taxi Online Booking"],
  ["Pune to Mumbai Taxi Booking Online", "Online Cab Booking Pune to Mumbai"],
  ["Pune to Mumbai Cab Online Booking", "Book Cab Online Pune to Mumbai"],
  ["Cab Booking Pune to Mumbai", "Taxi Booking Pune to Mumbai"],
  ["Pune to Mumbai One Way Cab Booking Online", "Pune to Mumbai Round Trip Cab Booking Online"],
  ["Pune to Mumbai Airport Cab Booking Online", "Innova Crysta Online Booking Pune to Mumbai"],
  ["Ertiga Cab Online Booking Pune to Mumbai", "Sedan Cab Online Booking Pune to Mumbai"],
  ["SUV Cab Online Booking Pune to Mumbai", "Pune to Mumbai One Way Cab Booking"]
],

whychoose: [
  {
    WhyChooseheading: "Convenient Online Booking from Pune",
    WhyChoosedescription: "Skyline Cab offers a seamless online booking system, allowing passengers to schedule their Pune to Mumbai cab effortlessly from any device. With just a few clicks, you can select pickup points across Pune, specify travel times, and confirm your ride instantly. The online platform provides real-time availability, fare estimates, and instant booking confirmation, making your intercity travel planning simple and stress-free."
  },
  {
    WhyChooseheading: "Experienced Highway and Expressway Drivers",
    WhyChoosedescription: "Our professional chauffeurs are highly skilled in driving on the Pune–Mumbai Expressway and city highways, maintaining safe speeds, smooth navigation, and disciplined lane usage. Their extensive experience ensures a comfortable, secure, and punctual journey. Whether traveling during peak hours or off-peak times, Skyline Cab guarantees an efficient ride from Pune to Mumbai."
  },
  {
    WhyChooseheading: "Punctual and Reliable Transfers",
    WhyChoosedescription: "Skyline Cab prioritizes on-time pickups and arrivals. Our team calculates travel time considering real-time traffic, tolls, and route options to ensure you reach your destination in Mumbai without delays. Whether it’s a business meeting, flight, or personal trip, you can rely on us for timely, hassle-free intercity transfers."
  },
  {
    WhyChooseheading: "Transparent Online Fare Estimates",
    WhyChoosedescription: "Our online booking system provides clear fare estimates upfront, covering tolls, driver allowance, and applicable taxes. With no hidden charges, passengers can confidently plan their budget. This transparency builds trust and ensures that Skyline Cab remains a reliable and fair choice for Pune to Mumbai travel."
  },
  {
    WhyChooseheading: "24/7 Online Booking and Support",
    WhyChoosedescription: "Skyline Cab’s online platform operates round-the-clock, allowing passengers to book trips at any hour. Coupled with 24/7 customer support, you can confirm bookings, receive driver details, and get real-time updates for your Pune to Mumbai journey. This flexibility is ideal for early morning, late-night, or last-minute travel plans."
  },
  {
    WhyChooseheading: "Comfortable and Hygienic AC Vehicles",
    WhyChoosedescription: "We provide air-conditioned, well-maintained vehicles with ample space for passengers and luggage. Regular cleaning and sanitation ensure a safe and comfortable ride. Whether traveling solo, with family, or as part of a corporate group, Skyline Cab guarantees a pleasant journey from Pune to Mumbai."
  },
  {
    WhyChooseheading: "Business and Leisure Travel Friendly",
    WhyChoosedescription: "Skyline Cab caters to corporate executives, business travelers, families, and leisure passengers alike. Our courteous drivers assist with luggage and provide smooth, comfortable rides. We ensure professionalism, punctuality, and convenience, making every Pune to Mumbai trip stress-free and enjoyable."
  },
  {
    WhyChooseheading: "Dedicated Customer Support for Online Bookings",
    WhyChoosedescription: "From the moment you book online until you reach Mumbai, Skyline Cab’s support team monitors your trip, providing driver contact details, live tracking, and immediate assistance if needed. Our focus on customer satisfaction ensures a smooth, reliable, and worry-free intercity travel experience every time."
  }
]

}

const faqData = [
    {
        id: 1,
        question: 'How can I complete Pune to Mumbai Cab Booking Online with Skyline Cabs?',
        answer:
            'Completing your Pune to Mumbai Cab Booking Online with Skyline Cabs is quick, secure, and hassle-free. Simply visit our website or mobile app, enter Pune as your pickup location and Mumbai as your drop destination, choose your preferred vehicle, and confirm your ride instantly. You will receive immediate booking confirmation along with complete driver and vehicle details. Our smooth online booking system ensures reliable intercity travel without last-minute complications.',
    },
    {
        id: 2,
        question: 'Is Pune to Mumbai Cab Booking Online available 24/7?',
        answer:
            'Yes, Skyline Cabs provides 24/7 Pune to Mumbai Cab Booking Online service for early morning, late-night, and same-day travel needs. Whether you are traveling for business, leisure, or airport transfers, our professional drivers ensure punctual pickup and comfortable highway travel via the Mumbai-Pune Expressway.',
    },
    {
        id: 3,
        question: 'What vehicle options are available for Pune to Mumbai Cab Booking Online?',
        answer:
            'We offer a wide range of vehicles including Swift Dzire, Ertiga, Innova Crysta, and premium SUVs for Pune to Mumbai Cab Booking Online. You can select an economical sedan for budget travel or choose a spacious SUV for family and group journeys. All vehicles are air-conditioned, well-maintained, and driven by experienced chauffeurs for safe long-distance travel.',
    },
    {
        id: 4,
        question: 'How much is the Pune to Mumbai Cab Booking Online fare?',
        answer:
            'The Pune to Mumbai Cab Booking Online fare depends on the vehicle type, travel date, and trip option (one-way or round trip). Skyline Cabs follows a transparent pricing policy where the final fare is clearly displayed before booking confirmation. The fare includes driver allowance and applicable charges with no hidden costs.',
    },
    {
        id: 5,
        question: 'Is one-way Pune to Mumbai Cab Booking Online available?',
        answer:
            'Yes, Skyline Cabs offers affordable one-way Pune to Mumbai Cab Booking Online service. You only pay for the distance traveled without unnecessary return charges. This option is ideal for business travelers, airport transfers, and single-direction travel needs.',
    },
    {
        id: 6,
        question: 'How long does it take to travel from Pune to Mumbai by cab?',
        answer:
            'The journey from Pune to Mumbai typically takes around 3 to 4 hours depending on traffic and travel time. Our experienced drivers use the Mumbai-Pune Expressway to ensure smooth, safe, and comfortable intercity travel with minimal delays.',
    },
    {
        id: 7,
        question: 'Is online payment available for Pune to Mumbai Cab Booking Online?',
        answer:
            'Yes, Skyline Cabs supports secure online payment options including UPI, credit cards, debit cards, and net banking. Once your payment is successfully completed, you receive instant booking confirmation along with trip and driver details for complete peace of mind.',
    },
    {
        id: 8,
        question: 'Can I pre-book Pune to Mumbai Cab Booking Online in advance?',
        answer:
            'Absolutely. You can pre-book your Pune to Mumbai Cab Booking Online for any future date and time. Advance booking ensures guaranteed vehicle availability, especially during weekends, holidays, and peak travel seasons.',
    },
    {
        id: 9,
        question: 'Is Pune to Mumbai Cab Booking Online suitable for corporate travel?',
        answer:
            'Yes, our Pune to Mumbai Cab Booking Online service is highly preferred by corporate professionals and business travelers. We provide punctual pickups, professional chauffeurs, clean vehicles, and reliable service for executive and business trips.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Pune to Mumbai Cab Booking Online?',
        answer:
            'Skyline Cabs is trusted for Pune to Mumbai Cab Booking Online because of our transparent pricing, professional drivers, sanitized vehicles, punctual service, and 24x7 customer support. We focus on delivering safe, reliable, and comfortable intercity travel experiences every time.',
    },
];

const someReviews = [
    {
        name: "Mr. Vivek Kulkarni",
        rating: 5,
        review: "Booked Pune to Mumbai Cab Booking Online with Skyline Cabs for my business meeting. The driver was punctual, the vehicle was clean, and the journey via expressway was smooth. Highly reliable intercity cab service!"
    },
    {
        name: "Ms. Neha Patil",
        rating: 4,
        review: "Very dependable Pune to Mumbai Cab Booking Online service. Transparent pricing and comfortable ride made our trip stress-free. Skyline Cabs provides professional and timely service."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Cab Booking Online",
  "image": "https://skylinecabs.com/assets/images/pune-to-mumbai-cab-booking-online.jpg",
  "description": "Book Pune to Mumbai Cab Online with Skyline Cabs for safe, comfortable, and timely travel. One-way and round-trip cab options available with AC, Innova Crysta, Ertiga, and Sedan cabs. Convenient online booking from Pune to Mumbai Airport or city destinations with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2599",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-to-mumbai-cab-booking-online"
  }
};


    
      


    return (
        <div>

<Helmet>
  <title>Pune to Mumbai Cab Booking Online | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Cab Online with Skyline Cabs for safe, comfortable, and timely travel. AC, Innova Crysta, Ertiga, and Sedan cabs available for one-way or round-trip from Pune to Mumbai Airport or city destinations." 
  />
  <meta 
    name="keywords" 
    content="mumbai airport to pune taxi online booking, pune to mumbai cab booking online, Pune to Mumbai Cab Booking Online, Pune to Mumbai Taxi Booking Online, Online Cab Booking Pune to Mumbai, Pune to Mumbai Cab Online Booking, Book Cab Online Pune to Mumbai, Cab Booking Pune to Mumbai, Taxi Booking Pune to Mumbai, Pune to Mumbai One Way Cab Booking Online, Pune to Mumbai Round Trip Cab Booking Online, Pune to Mumbai Airport Cab Booking Online, Innova Crysta Online Booking Pune to Mumbai, Skyline Cabs Pune to Mumbai Online Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/144.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaicabbookingonline;